import { parseCurrencyString } from "@/utils/parseCurrencyString";
import * as Yup from "yup";

export const PaymentPackageSchema = Yup.object().shape({
  client_id: Yup.string().required("Cliente é obrigatório"),

  package_id: Yup.string().required("Pacote é obrigatório"),

  discount_amount: Yup.string()
    .nullable()
    .transform(parseCurrencyString)
    .test("is-valid", "Valor deve ser um número válido", (value) => {
      if (!value) return true; // permite null, undefined ou ''
      const numberValue = parseFloat(value);
      return !isNaN(numberValue) && numberValue >= 0;
    }),

  // tip_amount: Yup.number()
  //     .transform((value, originalValue) => originalValue === '' ? null : Number(originalValue))
  //     .typeError('Gorjeta deve ser um número')
  //     .min(0, 'Gorjeta não pode ser negativa')
  //     .nullable(),

  payment_details: Yup.array()
    .of(
      Yup.object().shape({
        paid_amount: Yup.number()
          .transform((value, originalValue) =>
            originalValue === "" ? null : Number(originalValue),
          )
          .typeError("Valor pago deve ser um número")
          .min(0, "Valor pago não pode ser negativo")
          .required("Valor pago é obrigatório"),

        payment_method_id: Yup.string().required(
          "Método de pagamento é obrigatório",
        ),
      }),
    )
    .required("Detalhes do pagamento são obrigatórios"),
});
